<mat-progress-bar mode="indeterminate" [class._is_visible]="loaderVisible"></mat-progress-bar>
